<template>
  <div>
    <LinkTitle></LinkTitle>
    <div class="conatainer">
      <PageSearchTitle
        title="交易纠纷处理"
        hideSearch="true"
        :showCart="false"
      />
      <div class="box">
        <div class="tabsBox">
           <h2 class="title">交易纠纷处理声明</h2>
          <div class='titleHeader'>您可通过肉联所所支持的交易方式与其他用户达成交易，并遵守相应交易与支付规则。您理解并同意，肉联所仅作为用户物色交易对象，就产品和服务的交易进行协商，以及获取各类与贸易相关的服务的地点，肉联所不会参与用户间的交易，亦不会涉及用户间因交易而产生的法律关系及法律纠纷。</div>
          <p>您在肉联所交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：</p>
          <h5>（一）与争议相对方自主协商；</h5> 
          <h5>（二）使用肉联所提供的争议调处服务；</h5> 
          <h5>（三）向有关行政部门投诉；</h5> 
          <h5>（四）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</h5> 
          <h5>（五）向人民法院提起诉讼。</h5> 
          <p>
              如您依据肉联所规则使用肉联所的争议调处服务，则表示您认可并愿意履行肉联所的客服作为独立的第三方根据其所了解到的争议事实并依据肉联所规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方、执行相应的保证金赔付等）。在肉联所调处决定作出前，您可选择上述其他争议处理途径解决争议以中止肉联所的争议调处服务。如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。
              </p>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";

export default {
  name: "supplyPage",
  data() {
    return {};
  },
  components: {
    PageSearchTitle,
  },
  methods: {},
};
</script>

<style scoped lang='less'>
@media screen and(min-width:320px) and(max-width:1200px) {
  .conatainer {
    margin: 5px 10px 0 !important;
  }
}
.conatainer {
  margin: 5px 300px 0;
}
.box {
  margin-top: 20px;
  min-height: 300px;
}
.tabsBox {
}
.title{
    padding-top: 20px;
    margin-bottom: 40px;
}
h5{
    margin-top: 15px;
    margin-bottom: 15px;
    text-indent: 40px;
}
p{
    text-indent: 35px;
     color:#545454;
     font-size: 13px;
     margin-top: 10px;
     margin-bottom: 10px;
}
.titleHeader{
    text-indent: 35px;
     color:#545454;
     font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/agreement/IssueAgreement.vue